export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Oups, il y a eu une erreur !"])}
}